var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconProfilSmall(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 9.726,
    height: 15,
    viewBox: "0 0 9.726 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Komponente_133_10",
    "data-name": "Komponente 133 \\u2013 10",
    transform: "translate(0.504 0.5)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_44",
    "data-name": "Ellipse 44",
    cx: 2.47,
    cy: 2.5,
    rx: 2.47,
    ry: 2.5,
    transform: "translate(1.859)",
    fill: "none",
    stroke: "#00C4DE",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_388",
    "data-name": "Pfad 388",
    d: "M972.7,767.5h5.584a1.537,1.537,0,0,1,1.507,1.778l-.833,5.477a.637.637,0,0,1-.628.545H972.69a.637.637,0,0,1-.625-.529l-.949-5.353A1.624,1.624,0,0,1,972.7,767.5Z",
    transform: "translate(-971.09 -761.3)",
    fill: "none",
    stroke: "#00C4DE",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconProfilSmall);
export default __webpack_public_path__ + "static/media/icon_profil_small.aca74e69bc20895a35f3ba0cc5138c13.svg";
export { ForwardRef as ReactComponent };